import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import L from 'leaflet';
import { useTranslation } from 'react-i18next';
import Input from '../../../../ui/Input';
import { Circle, MapContainer, Marker, TileLayer, useMapEvents } from 'react-leaflet';
import { INITIAL_ADMIN_TASK_LOCATION_COORDINATES } from '../../../../app.config.vars/stored';
import RecenterMap from './RecenterMap';
import pinIcon from '../../../../assets/icons/pin-map.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import Button from '../../../../ui/Button';
import ButtonsGroup from '../../../../ui/ButtonsGroup';
import CurrentLocationIcon from '../../../../assets/icons/current_location.svg';
import Tooltip from '../../../../ui/Tooltip';
import InfoIcon from '../../../../assets/icons/info.svg';
const defaultIcon = new L.Icon({
    iconUrl: pinIcon,
    iconSize: [27, 42],
    iconAnchor: [13, 42],
    popupAnchor: [0, -42],
    shadowUrl: markerShadow,
});
const LocationTaskFields = ({ refs, formState, formErrors, validateInputField, setUpdatedFormFields, formType, }) => {
    const { t } = useTranslation();
    const [forceFitBounds, setForceFitBounds] = useState(true);
    const [marker, setMarker] = useState(+formState.coordinatesLat !== 0 && +formState.coordinatesLon !== 0
        ? [+formState.coordinatesLat, +formState.coordinatesLon]
        : null);
    const recenterMap = () => {
        setForceFitBounds(true);
        setTimeout(() => setForceFitBounds(false), 500); // Reset the flag after a short delay
    };
    const updateCoordinates = (lat, lon) => {
        formState.setCoordinatesLat(lat);
        formState.setCoordinatesLon(lon);
        setUpdatedFormFields((prev) => {
            const newSet = new Set(prev);
            newSet.add('coordinatesLat');
            newSet.add('coordinatesLon');
            return newSet;
        });
        setMarker([lat, lon]);
        recenterMap();
    };
    const LocationMarker = () => {
        useMapEvents({
            click(event) {
                const { lat, lng } = event.latlng;
                updateCoordinates(lat, lng);
            },
        });
        return marker ? _jsx(Marker, { position: marker, icon: defaultIcon }) : null;
    };
    useEffect(() => {
        if (!isNaN(+formState.coordinatesLat) && !isNaN(+formState.coordinatesLon)) {
            setMarker(null);
            recenterMap();
            if (+formState.coordinatesLat !== 0 && +formState.coordinatesLon !== 0) {
                setMarker([+formState.coordinatesLat, +formState.coordinatesLon]);
            }
        }
    }, [formState.coordinatesLat, formState.coordinatesLon]);
    const handleUseCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert(t('error.geolocation_not_supported'));
            return;
        }
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            updateCoordinates(latitude, longitude);
        }, (error) => {
            console.error(error);
            alert(t('error.unable_to_get_location'));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "label", children: [t('label.target_point_coordinates'), _jsx(Tooltip, { content: t('tooltip.coordinates'), position: "top", children: _jsx(InfoIcon, { style: {
                                width: '16px',
                                height: '16px',
                                marginLeft: '4px',
                                cursor: 'help',
                                display: 'inline-block',
                                verticalAlign: 'middle',
                            } }) })] }), _jsxs("div", { className: "map-container", children: [_jsxs(MapContainer, { center: +formState.coordinatesLat === 0 && +formState.coordinatesLon === 0
                            ? [
                                INITIAL_ADMIN_TASK_LOCATION_COORDINATES.lat,
                                INITIAL_ADMIN_TASK_LOCATION_COORDINATES.lng,
                            ]
                            : [+formState.coordinatesLat, +formState.coordinatesLon], zoom: 15, style: { height: '100%', width: '100%' }, children: [_jsx(TileLayer, { url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' }), _jsx(LocationMarker, {}), +formState.coordinatesLat !== 0 && +formState.coordinatesLon !== 0 && (_jsx(Circle, { center: [+formState.coordinatesLat, +formState.coordinatesLon], radius: formState.radius, pathOptions: {
                                    color: '#1C6DF4',
                                    fillColor: '#76B8FF',
                                    fillOpacity: 0.68,
                                    weight: 2,
                                } })), forceFitBounds && _jsx(RecenterMap, { marker: marker })] }), _jsx("button", { className: 'map-control-button', onClick: recenterMap, children: t('button.recenter_map') })] }), _jsx(Input, { type: 'number', ref: refs.coordinatesLat, id: "coordinatesLat", value: String(formState.coordinatesLat !== null ? formState.coordinatesLat : ''), name: "coordinatesLat", label: t('label.coordinates_lat'), labelPosition: 'left', labelWidth: '155px', onChange: (event) => {
                    formState.setCoordinatesLat(+event.target.value);
                    validateInputField({
                        fieldName: 'coordinatesLat',
                        value: event.currentTarget.value || '0',
                    });
                    setUpdatedFormFields((prev) => {
                        const newSet = new Set(prev);
                        newSet.add('coordinatesLat');
                        return newSet;
                    });
                }, error: !!formErrors.coordinatesLat?.length, errorMessage: !!formErrors.coordinatesLat?.length
                    ? t(formErrors.coordinatesLat[0].messageTranslationKey)
                    : undefined, errorBorder: formType === 'edit' && formState.coordinatesLat === 0 }), _jsx(Input, { type: 'number', ref: refs.coordinatesLon, id: "coordinatesLon", value: String(formState.coordinatesLon !== null ? formState.coordinatesLon : ''), name: "coordinatesLon", label: t('label.coordinates_lon'), labelPosition: 'left', labelWidth: '155px', onChange: (event) => {
                    formState.setCoordinatesLon(+event.target.value);
                    validateInputField({
                        fieldName: 'coordinatesLon',
                        value: event.currentTarget.value || '0',
                    });
                    setUpdatedFormFields((prev) => {
                        const newSet = new Set(prev);
                        newSet.add('coordinatesLon');
                        return newSet;
                    });
                }, error: !!formErrors.coordinatesLon?.length, errorMessage: !!formErrors.coordinatesLon?.length
                    ? t(formErrors.coordinatesLon[0].messageTranslationKey)
                    : undefined, errorBorder: formType === 'edit' && formState.coordinatesLon === 0 }), _jsx(Input, { type: 'number', ref: refs.radius, id: "radius", value: String(formState.radius), name: "radius", label: t('label.radius'), labelPosition: 'left', labelWidth: '155px', tooltipContent: t('tooltip.radius'), onChange: (event) => {
                    formState.setRadius(+event.currentTarget.value);
                    validateInputField({ fieldName: 'radius', value: event.currentTarget.value || '0' });
                    setUpdatedFormFields((prev) => {
                        const newSet = new Set(prev);
                        newSet.add('radius');
                        return newSet;
                    });
                }, error: !!formErrors.radius?.length, errorMessage: !!formErrors.radius?.length ? t(formErrors.radius[0].messageTranslationKey) : undefined, errorBorder: formType === 'edit' && formState.radius === 0 }), _jsx(ButtonsGroup, { justify: 'end', children: _jsx(Button, { variant: 'outlined', onClick: handleUseCurrentLocation, label: t('button.use_current_location'), icon: _jsx(CurrentLocationIcon, {}) }) })] }));
};
export default LocationTaskFields;
